import { render } from "./LockItInProductButtons.vue?vue&type=template&id=99cad7d8&scoped=true"
import script from "./LockItInProductButtons.vue?vue&type=script&lang=js"
export * from "./LockItInProductButtons.vue?vue&type=script&lang=js"

import "./LockItInProductButtons.vue?vue&type=style&index=0&id=99cad7d8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99cad7d8"]])

export default __exports__